export const getLocalStorage = (key: string) => {
  if (typeof window === 'undefined') return null;

  const value = window.localStorage.getItem(key);
  if (!value) return value;

  // setLocalStorage(key, undefined) grava a string "undefined", que passa no if e quebra o parse.
  // Chave corrompida por versão anterior do código também cai aqui e não pode derrubar a página.
  try {
    return JSON.parse(value);
  } catch {
    window.localStorage.removeItem(key);
    return null;
  }
};

export const getLocalStorageWithoutParse = (key: string) => {
  if (typeof window !== 'undefined') {
    return window.localStorage.getItem(key);
  }
  return null;
};

export const setLocalStorage = (key: string, value: any) => {
  if (typeof window !== 'undefined') {
    if (value === undefined) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, JSON.stringify(value));
    }
  }
  return getLocalStorage(key);
};

export const setLocalStorageWithoutParse = (key: string, value: any) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(key, value);
  }
  return getLocalStorageWithoutParse(key);
};

export const removeLocalStorage = (key: string) => {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(key);
  }
};

export const clearLocalStorage = () => {
  if (typeof window !== 'undefined') {
    window.localStorage.clear();
  }
};

export const CART_LOCAL_STORAGE_KEY = 'cart';
export const DONATION_LOCAL_STORAGE_KEY = 'donation';
